import React, { useEffect, useState } from 'react';
import { listChatMessagesAPI, sendChatMessageAPI } from '../../services/api';

const ChatPanel = ({ roomCode, user }) => {
  const [text, setText] = useState('');
  const [messages, setMessages] = useState([]);
  const [lastTimestamp, setLastTimestamp] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchMessages = async () => {
      try {
        const data = await listChatMessagesAPI(roomCode, lastTimestamp);
        if (!isMounted) return;
        if (data && data.messages) {
          setMessages((prev) => [...prev, ...data.messages]);
          if (data.messages.length > 0) {
            const last = data.messages[data.messages.length - 1];
            setLastTimestamp(last.created_at);
          }
        }
      } catch (err) {
        console.error('Chat fetch error', err);
      }
    };

    fetchMessages();
    const interval = setInterval(fetchMessages, 2000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [roomCode, lastTimestamp]);

  const handleSend = async (e) => {
    e.preventDefault();
    const msg = text.trim();
    if (!msg) return;
    try {
      await sendChatMessageAPI(roomCode, user.id, user.name, msg);
      setText('');
      // Next poll will fetch it; optionally optimistic update
    } catch (err) {
      console.error('Chat send error', err);
    }
  };

  return (
    <div className="card h-100">
      <div className="card-header">Chat</div>
      <div className="card-body d-flex flex-column">
        <div className="chat-messages mb-2">
          {messages.map((m) => (
            <div key={m.id} className="mb-1">
              <strong>{m.user_name}</strong>{' '}
              <small className="text-muted">
                {new Date(m.created_at).toLocaleTimeString()}
              </small>
              <div>{m.message}</div>
            </div>
          ))}
          {messages.length === 0 && (
            <div className="text-muted">No messages yet.</div>
          )}
        </div>
        <form onSubmit={handleSend} className="mt-auto">
          <div className="input-group">
            <input
              className="form-control"
              placeholder="Type a message..."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <button className="btn btn-primary" type="submit">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatPanel;
